import { render } from "./AppWidget.vue?vue&type=template&id=b4b96f04&scoped=true"
import script from "./AppWidget.vue?vue&type=script&lang=js"
export * from "./AppWidget.vue?vue&type=script&lang=js"

import "./AppWidget.vue?vue&type=style&index=0&id=b4b96f04&scoped=true&lang=css"
import "./AppWidget.vue?vue&type=style&index=1&id=b4b96f04&lang=css"

import exportComponent from "/home/sergey/projects/tm/calc_furnace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b96f04"]])

export default __exports__